import { render, staticRenderFns } from "./Varios.vue?vue&type=template&id=f9c2282e&scoped=true"
import script from "./Varios.vue?vue&type=script&lang=js"
export * from "./Varios.vue?vue&type=script&lang=js"
import style0 from "./Varios.vue?vue&type=style&index=0&id=f9c2282e&prod&lang=scss&scoped=true"
import style1 from "./Varios.vue?vue&type=style&index=1&id=f9c2282e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c2282e",
  null
  
)

export default component.exports